import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import store from '../Store';

interface EditUserModalProps {
  user: any;
  isOpen: boolean;
  onClose: () => void;
  onSave: (userData: any) => void;
}

const EditUserModal: React.FC<EditUserModalProps> = ({ user, isOpen, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    first_name: '',
    first_name_ar: '',
    last_name: '',
    last_name_ar: '',
    email: '',
    phone: '',
    bio: '',
    address: '',
    date_of_birth: '',
    gender: '',
    type: '',
    account_status: ''
  });

  useEffect(() => {
    if (user) {
      setFormData({
        first_name: user.first_name || '',
        first_name_ar: user.first_name_ar || '',
        last_name: user.last_name || '',
        last_name_ar: user.last_name_ar || '',
        email: user.email || '',
        phone: user.phone || '',
        bio: user.bio || '',
        address: user.address || '',
        date_of_birth: user.date_of_birth || '',
        gender: user.gender || '',
        type: user.type || '',
        account_status: user.account_status || ''
      });
    }
  }, [user]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(formData);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-2xl max-h-[90vh] overflow-hidden">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4">
          تعديل بيانات المستخدم
        </h3>
        <form onSubmit={handleSubmit}>
          <div className="space-y-4 max-h-96 overflow-y-auto">
            {/* الاسم الأول - English */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                الاسم الأول (إنجليزي)
              </label>
              <input
                type="text"
                value={formData.first_name}
                onChange={(e) => setFormData({...formData, first_name: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                required
              />
            </div>

            {/* الاسم الأول - Arabic */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                الاسم الأول (عربي)
              </label>
              <input
                type="text"
                value={formData.first_name_ar}
                onChange={(e) => setFormData({...formData, first_name_ar: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              />
            </div>

            {/* الاسم الأخير - English */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                الاسم الأخير (إنجليزي)
              </label>
              <input
                type="text"
                value={formData.last_name}
                onChange={(e) => setFormData({...formData, last_name: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                required
              />
            </div>

            {/* الاسم الأخير - Arabic */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                الاسم الأخير (عربي)
              </label>
              <input
                type="text"
                value={formData.last_name_ar}
                onChange={(e) => setFormData({...formData, last_name_ar: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              />
            </div>

            {/* البريد الإلكتروني */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                البريد الإلكتروني
              </label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                required
              />
            </div>

            {/* رقم الهاتف */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                رقم الهاتف
              </label>
              <input
                type="tel"
                value={formData.phone}
                onChange={(e) => setFormData({...formData, phone: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              />
            </div>

            {/* النبذة الشخصية */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                النبذة الشخصية
              </label>
              <textarea
                value={formData.bio}
                onChange={(e) => setFormData({...formData, bio: e.target.value})}
                rows={3}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                placeholder="اكتب نبذة عن المستخدم..."
              />
            </div>

            {/* العنوان */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                العنوان
              </label>
              <input
                type="text"
                value={formData.address}
                onChange={(e) => setFormData({...formData, address: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                placeholder="العنوان الكامل..."
              />
            </div>

            {/* تاريخ الميلاد */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                تاريخ الميلاد
              </label>
              <input
                type="date"
                value={formData.date_of_birth}
                onChange={(e) => setFormData({...formData, date_of_birth: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              />
            </div>

            {/* نوع الجنس */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                نوع الجنس
              </label>
              <select
                value={formData.gender}
                onChange={(e) => setFormData({...formData, gender: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              >
                <option value="">اختر نوع الجنس</option>
                <option value="male">ذكر</option>
                <option value="female">أنثى</option>
                <option value="other">آخر</option>
              </select>
            </div>

            {/* الدور */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                الدور
              </label>
              <select
                value={formData.type}
                onChange={(e) => setFormData({...formData, type: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              >
                <option value="client">عميل</option>
                <option value="service_provider">مقدم خدمة</option>
                <option value="admin">مدير</option>
              </select>
            </div>

            {/* الحالة */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                الحالة
              </label>
              <select
                value={formData.account_status}
                onChange={(e) => setFormData({...formData, account_status: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              >
                <option value="active">نشط</option>
                <option value="inactive">غير نشط</option>
                <option value="pending">معلق</option>
                <option value="blocked">محظور</option>
              </select>
            </div>
          </div>
          <div className="flex justify-end space-x-3 space-x-reverse mt-6">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white dark:border-gray-600 dark:hover:bg-gray-600"
            >
              إلغاء
            </button>
            <button
              type="submit"
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              حفظ التغييرات
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const UsersPage: React.FC = observer(() => {
  console.log('UsersPage: Component initialized');
  
  const [searchTerm, setSearchTerm] = useState('');
  const [filterRole, setFilterRole] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState<{type: 'success' | 'error', message: string} | null>(null);

  useEffect(() => {
    console.log('UsersPage: useEffect called, fetching users...');
    store.fetchUsers();
  }, []);

  const filteredUsers = store.users.filter(user => {
    // البحث في الاسم (إنجليزي وعربي) والبريد الإلكتروني
    const fullNameEn = `${user.first_name || ''} ${user.last_name || ''}`.toLowerCase();
    const fullNameAr = `${user.first_name_ar || ''} ${user.last_name_ar || ''}`.toLowerCase();
    const email = (user.email || '').toLowerCase();
    const searchLower = searchTerm.toLowerCase();
    
    const matchesSearch = searchTerm === '' || 
                         fullNameEn.includes(searchLower) ||
                         fullNameAr.includes(searchLower) ||
                         email.includes(searchLower);
    
    // فلترة الدور - تحسين المنطق
    let matchesRole = true;
    if (filterRole !== 'all') {
      if (filterRole === 'service_provider') {
        // مقدم خدمة: إما له دور service_provider أو له خدمة أو account_status = premium
        matchesRole = user.type === 'service_provider' || 
                     Boolean(user.service?.id) || 
                     user.account_status === 'premium';
      } else if (filterRole === 'client') {
        // عميل: ليس له دور service_provider ولا له خدمة وليس premium
        matchesRole = user.type === 'client' && 
                     !Boolean(user.service?.id) && 
                     user.account_status !== 'premium';
      } else {
        matchesRole = user.type === filterRole;
      }
    }
    
    // فلترة الحالة - تحسين المنطق
    let matchesStatus = true;
    if (filterStatus !== 'all') {
      matchesStatus = user.account_status === filterStatus;
    }
    
    return matchesSearch && matchesRole && matchesStatus;
  });

  const showNotification = (type: 'success' | 'error', message: string) => {
    setNotification({ type, message });
    setTimeout(() => setNotification(null), 5000);
  };

  const handleApproveUser = async (userId: string) => {
    setIsLoading(true);
    try {
      const result = await store.approveAccount(userId);
      const isSuccess = result?.success === true || result?.status === 'success';
      if (!isSuccess) {
        throw new Error(result?.message || 'Approval failed');
      }
      await store.fetchUsers();
      showNotification('success', 'تم تفعيل المستخدم بنجاح');
    } catch (error) {
      console.error('Error approving user:', error);
      showNotification('error', 'فشل في تفعيل المستخدم');
    } finally {
      setIsLoading(false);
    }
  };

  const handleBlockUser = async (userId: string) => {
    setIsLoading(true);
    try {
      await store.blockProfile(userId);
      await store.fetchUsers();
      showNotification('success', 'تم حظر المستخدم بنجاح');
    } catch (error) {
      console.error('Error blocking user:', error);
      showNotification('error', 'فشل في حظر المستخدم');
    } finally {
      setIsLoading(false);
    }
  };

  const handleUnblockUser = async (userId: string) => {
    setIsLoading(true);
    try {
      await store.unblockProfile(userId);
      await store.fetchUsers();
      showNotification('success', 'تم إلغاء حظر المستخدم بنجاح');
    } catch (error) {
      console.error('Error unblocking user:', error);
      showNotification('error', 'فشل في إلغاء حظر المستخدم');
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditUser = (user: any) => {
    setSelectedUser(user);
    setIsEditModalOpen(true);
  };

  const handleSaveUser = async (userData: any) => {
    setIsLoading(true);
    try {
      console.log('UsersPage: Sending user data:', userData);
      // Filter out empty/null values
      const filteredData = Object.fromEntries(
        Object.entries(userData).filter(([key, value]) => 
          value !== null && value !== undefined && value !== ''
        )
      );
      console.log('UsersPage: Filtered user data:', filteredData);
      await store.updateUser(selectedUser.id, filteredData);
      showNotification('success', 'تم تحديث بيانات المستخدم بنجاح');
      setIsEditModalOpen(false);
    } catch (error) {
      console.error('Error updating user:', error);
      showNotification('error', 'فشل في تحديث بيانات المستخدم');
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteUser = async (userId: string) => {
    if (globalThis.confirm('هل أنت متأكد من حذف هذا المستخدم؟')) {
      setIsLoading(true);
      try {
        await store.deleteUser(userId);
        showNotification('success', 'تم حذف المستخدم بنجاح');
      } catch (error) {
        console.error('Error deleting user:', error);
        showNotification('error', 'فشل في حذف المستخدم');
      } finally {
        setIsLoading(false);
      }
    }
  };

  console.log('UsersPage: Rendering, isLoading:', store.isLoading, 'users count:', store.users.length);

  if (store.isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  // Calculate statistics
  const totalUsers = store.users.length;
  const activeUsers = store.users.filter(user => ['active', 'premium'].includes(user.account_status)).length;
  const pendingUsers = store.users.filter(user => user.account_status === 'pending').length;
  const blockedUsers = store.users.filter(user => user.account_status === 'blocked').length;
  
  // Calculate user type statistics
  const serviceProviders = store.users.filter(user => 
    user.type === 'service_provider' || 
    (user.service?.id) || 
    user.account_status === 'premium'
  ).length;
  const clients = store.users.filter(user => 
    user.type === 'client' && 
    !(user.service?.id) && 
    user.account_status !== 'premium'
  ).length;

  // معلومات تشخيصية
  const userTypes = Array.from(new Set(store.users.map(u => {
    if (u.type === 'admin') return 'admin';
    if (u.type === 'service_provider' || (u.service?.id) || u.account_status === 'premium') return 'service_provider';
    return 'client';
  })));
  const userStatuses = Array.from(new Set(store.users.map(u => u.account_status).filter(Boolean)));
  
  console.log('UsersPage: Total users:', store.users.length);
  console.log('UsersPage: Available types:', userTypes);
  console.log('UsersPage: Available statuses:', userStatuses);
  console.log('UsersPage: Service providers count:', serviceProviders);
  console.log('UsersPage: Clients count:', clients);
  console.log('UsersPage: Current filters - Role:', filterRole, 'Status:', filterStatus, 'Search:', searchTerm);
  console.log('UsersPage: Filtered users count:', filteredUsers.length);

  return (
    <div className="p-6">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">إدارة المستخدمين</h1>
        <p className="text-gray-600 dark:text-gray-400">عرض وإدارة جميع المستخدمين في النظام</p>
      </div>

      {/* Statistics Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-6 mb-6">
        <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-blue-500 rounded-md flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                </svg>
              </div>
            </div>
            <div className="mr-4">
              <p className="text-sm font-medium text-gray-500 dark:text-gray-400">إجمالي المستخدمين</p>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white">{totalUsers}</p>
            </div>
          </div>
        </div>

        <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-green-500 rounded-md flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
            </div>
            <div className="mr-4">
              <p className="text-sm font-medium text-gray-500 dark:text-gray-400">المستخدمون النشطون</p>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white">{activeUsers}</p>
            </div>
          </div>
        </div>

        <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-yellow-500 rounded-md flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
            </div>
            <div className="mr-4">
              <p className="text-sm font-medium text-gray-500 dark:text-gray-400">في الانتظار</p>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white">{pendingUsers}</p>
            </div>
          </div>
        </div>

        <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-red-500 rounded-md flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728L5.636 5.636m12.728 12.728L18.364 5.636M5.636 18.364l12.728-12.728" />
                </svg>
              </div>
            </div>
            <div className="mr-4">
              <p className="text-sm font-medium text-gray-500 dark:text-gray-400">المحظورون</p>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white">{blockedUsers}</p>
            </div>
          </div>
        </div>

        <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-purple-500 rounded-md flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
            </div>
            <div className="mr-4">
              <p className="text-sm font-medium text-gray-500 dark:text-gray-400">مقدمو الخدمات</p>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white">{serviceProviders}</p>
            </div>
          </div>
        </div>

        <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-orange-500 rounded-md flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
            </div>
            <div className="mr-4">
              <p className="text-sm font-medium text-gray-500 dark:text-gray-400">العملاء</p>
              <p className="text-2xl font-semibold text-gray-900 dark:text-white">{clients}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Notification */}
      {notification && (
        <div className={`mb-4 p-4 rounded-md ${
          notification.type === 'success' 
            ? 'bg-green-50 text-green-800 dark:bg-green-900 dark:text-green-200' 
            : 'bg-red-50 text-red-800 dark:bg-red-900 dark:text-red-200'
        }`}>
          <div className="flex">
            <div className="flex-shrink-0">
              {notification.type === 'success' ? (
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              ) : (
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
              )}
            </div>
            <div className="mr-3">
              <p className="text-sm font-medium">{notification.message}</p>
            </div>
          </div>
        </div>
      )}

      {/* Filters */}
      <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6 mb-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              البحث
            </label>
            <div className="relative">
              <input
                type="text"
                placeholder="البحث بالاسم (عربي/إنجليزي) أو البريد الإلكتروني..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full px-3 py-2 pl-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              />
              <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
            </div>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              الدور
            </label>
            <select
              value={filterRole}
              onChange={(e) => setFilterRole(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            >
              <option value="all">جميع الأدوار</option>
              <option value="client">عميل</option>
              <option value="service_provider">مقدم خدمة</option>
              <option value="admin">مدير</option>
            </select>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              الحالة
            </label>
            <select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            >
              <option value="all">جميع الحالات</option>
              <option value="active">نشط</option>
              <option value="pending">معلق</option>
              <option value="blocked">محظور</option>
              <option value="inactive">غير نشط</option>
            </select>
          </div>
          
          <div className="flex items-end">
            <button
              onClick={() => {
                setSearchTerm('');
                setFilterRole('all');
                setFilterStatus('all');
              }}
              className="w-full px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white dark:border-gray-600 dark:hover:bg-gray-600"
            >
              إعادة تعيين
            </button>
          </div>
        </div>
      </div>

      {/* Results Count */}
      <div className="mb-4 text-sm text-gray-600 dark:text-gray-400">
        عرض {filteredUsers.length} من أصل {store.users.length} مستخدم
        {filterRole !== 'all' && (
          <span className="mr-2 text-blue-600">(مفلتر حسب الدور: {filterRole})</span>
        )}
        {filterStatus !== 'all' && (
          <span className="mr-2 text-green-600">(مفلتر حسب الحالة: {filterStatus})</span>
        )}
        {searchTerm && (
          <span className="mr-2 text-purple-600">(مفلتر حسب البحث: {searchTerm})</span>
        )}
      </div>

      {/* معلومات تشخيصية - يمكن إزالتها لاحقاً */}
      {process.env.NODE_ENV === 'development' && (
        <div className="mb-4 p-4 bg-yellow-50 dark:bg-yellow-900 rounded-lg">
          <h4 className="font-medium text-yellow-800 dark:text-yellow-200 mb-2">معلومات تشخيصية:</h4>
          <div className="text-sm text-yellow-700 dark:text-yellow-300">
            <p>الأدوار المتاحة: {userTypes.join(', ') || 'لا توجد'}</p>
            <p>الحالات المتاحة: {userStatuses.join(', ') || 'لا توجد'}</p>
            <p>مقدمو الخدمات: {serviceProviders} | العملاء: {clients}</p>
            <p>الفلتر الحالي - الدور: {filterRole}, الحالة: {filterStatus}</p>
          </div>
        </div>
      )}

      {/* Users Table */}
      <div className="bg-white dark:bg-gray-800 shadow rounded-lg overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
          <h3 className="text-lg font-medium text-gray-900 dark:text-white">قائمة المستخدمين</h3>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
            <thead className="bg-gray-50 dark:bg-gray-700">
              <tr>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                  المستخدم
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                  البريد الإلكتروني
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                  الهاتف
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                  النوع
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                  الدور
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                  الحالة
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                  تاريخ الإنشاء
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                  الإجراءات
                </th>
              </tr>
            </thead>
            <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
              {filteredUsers.map((user) => (
                <tr key={user.id} className="hover:bg-gray-50 dark:hover:bg-gray-700">
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <div className="flex-shrink-0 h-10 w-10">
                        {user.image_path || user.photo ? (
                          <img 
                            className="h-10 w-10 rounded-full object-cover" 
                            src={user.image_path || user.photo} 
                            alt={`${user.first_name} ${user.last_name}`}
                            onError={(e) => {
                              e.currentTarget.style.display = 'none';
                              e.currentTarget.nextElementSibling?.classList.remove('hidden');
                            }}
                          />
                        ) : null}
                        <div className={`h-10 w-10 rounded-full bg-gray-300 dark:bg-gray-600 flex items-center justify-center ${user.image_path || user.photo ? 'hidden' : ''}`}>
                          <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                            {(user.first_name || 'U').charAt(0).toUpperCase()}
                          </span>
                        </div>
                      </div>
                      <div className="mr-4">
                        <div className="text-sm font-medium text-gray-900 dark:text-white">
                          {user.first_name || 'غير محدد'} {user.last_name || ''}
                        </div>
                        {(user.first_name_ar || user.last_name_ar) && (
                          <div className="text-sm text-gray-500 dark:text-gray-400">
                            {user.first_name_ar || ''} {user.last_name_ar || ''}
                          </div>
                        )}
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                    {user.email || 'غير محدد'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                    {user.phone || 'غير محدد'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {(() => {
                      const genderColors = {
                        male: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
                        female: 'bg-pink-100 text-pink-800 dark:bg-pink-900 dark:text-pink-200',
                        other: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200'
                      };
                      const genderLabels = {
                        male: 'ذكر',
                        female: 'أنثى',
                        other: 'آخر'
                      };
                      const gender = user.gender || 'unknown';
                      const colorClass = genderColors[gender as keyof typeof genderColors] || 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200';
                      const label = genderLabels[gender as keyof typeof genderLabels] || 'غير محدد';
                      
                      return (
                        <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${colorClass}`}>
                          {label}
                        </span>
                      );
                    })()}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {(() => {
                      // تحديد نوع المستخدم بناءً على البيانات المتاحة
                      let userType = 'client';
                      if (user.type === 'admin') {
                        userType = 'admin';
                      } else if (user.type === 'service_provider' || 
                                 (user.service?.id) || 
                                 user.account_status === 'premium') {
                        userType = 'service_provider';
                      }

                      const roleColors = {
                        admin: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
                        service_provider: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
                        client: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
                      };
                      const roleLabels = {
                        admin: 'مدير',
                        service_provider: 'مقدم خدمة',
                        client: 'عميل'
                      };
                      
                      const colorClass = roleColors[userType as keyof typeof roleColors] || 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200';
                      const label = roleLabels[userType as keyof typeof roleLabels] || 'عميل';
                      
                      return (
                        <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${colorClass}`}>
                          {label}
                        </span>
                      );
                    })()}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {(() => {
                      const statusColors = {
                        active: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
                        premium: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
                        pending: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
                        blocked: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
                        inactive: 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200'
                      };
                      const statusLabels = {
                        active: 'نشط',
                        premium: 'نشط مميز',
                        pending: 'معلق',
                        blocked: 'محظور',
                        inactive: 'غير نشط'
                      };
                      const status = user.account_status || 'inactive';
                      const colorClass = statusColors[status as keyof typeof statusColors] || 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200';
                      const label = statusLabels[status as keyof typeof statusLabels] || 'غير نشط';
                      
                      return (
                        <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${colorClass}`}>
                          {label}
                        </span>
                      );
                    })()}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">
                    {user.created_at ? new Date(user.created_at).toLocaleDateString('ar-SA') : 'غير محدد'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <div className="flex flex-wrap gap-2">
                      {/* Edit Button */}
                      <button
                        onClick={() => handleEditUser(user)}
                        className="inline-flex items-center px-2 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:hover:bg-gray-600"
                        title="تعديل"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                      </button>

                      {/* Approve/Block Buttons */}
                      {!['active', 'premium'].includes(user.account_status) && (
                        <button
                          onClick={() => handleApproveUser(user.id)}
                          disabled={isLoading}
                          className="inline-flex items-center px-2 py-1.5 border border-transparent shadow-sm text-xs font-medium rounded text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:opacity-50"
                          title="تفعيل"
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                        </button>
                      )}
                      
                      {['active', 'premium'].includes(user.account_status) ? (
                        <button
                          onClick={() => handleBlockUser(user.id)}
                          disabled={isLoading}
                          className="inline-flex items-center px-2 py-1.5 border border-transparent shadow-sm text-xs font-medium rounded text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50"
                          title="حظر"
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728L5.636 5.636m12.728 12.728L18.364 5.636M5.636 18.364l12.728-12.728" />
                          </svg>
                        </button>
                      ) : (
                        <button
                          onClick={() => handleUnblockUser(user.id)}
                          disabled={isLoading}
                          className="inline-flex items-center px-2 py-1.5 border border-transparent shadow-sm text-xs font-medium rounded text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
                          title="إلغاء الحظر"
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                          </svg>
                        </button>
                      )}

                      {/* Delete Button */}
                      <button
                        onClick={() => handleDeleteUser(user.id)}
                        disabled={isLoading}
                        className="inline-flex items-center px-2 py-1.5 border border-transparent shadow-sm text-xs font-medium rounded text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50"
                        title="حذف"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        
        {filteredUsers.length === 0 && (
          <div className="text-center py-12">
            <div className="mx-auto h-12 w-12 text-gray-400">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
              </svg>
            </div>
            <h3 className="mt-2 text-sm font-medium text-gray-900 dark:text-white">لا توجد مستخدمين</h3>
            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
              {searchTerm || filterRole !== 'all' || filterStatus !== 'all' 
                ? 'لا توجد مستخدمين مطابقين للبحث أو الفلترة' 
                : 'لم يتم العثور على أي مستخدمين في النظام'}
            </p>
            {(searchTerm || filterRole !== 'all' || filterStatus !== 'all') && (
              <div className="mt-6">
                <button
                  onClick={() => {
                    setSearchTerm('');
                    setFilterRole('all');
                    setFilterStatus('all');
                  }}
                  className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  إعادة تعيين الفلاتر
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Edit User Modal */}
      <EditUserModal
        user={selectedUser}
        isOpen={isEditModalOpen}
        onClose={() => {
          setIsEditModalOpen(false);
          setSelectedUser(null);
        }}
        onSave={handleSaveUser}
      />

      {/* Loading Overlay */}
      {isLoading && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 flex items-center space-x-3 space-x-reverse">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
            <span className="text-gray-900 dark:text-white">جاري المعالجة...</span>
          </div>
        </div>
      )}
    </div>
  );
});

export default UsersPage;
